import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import {
    AbstractControl,
    ControlValueAccessor,
    FormBuilder,
    FormGroup,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR, ValidationErrors
} from "@angular/forms";
import {Observable, Subscription} from "rxjs";
import {debounceTime, delay, filter, map, startWith} from "rxjs/operators";
import {SensorEventStatement} from "../../ParseClass/SensorEvent.Parse";
import {isNotNullOrUndefined} from "../../providers/service/global-variables.service";

@Component({
    selector: 'app-on-off-slide-button',
    templateUrl: './on-off-slide-button.component.html',
    styleUrls: ['./on-off-slide-button.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: OnOffSlideButtonComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: OnOffSlideButtonComponent
        }
    ],
    standalone: false
})
export class OnOffSlideButtonComponent implements OnInit, OnChanges, OnDestroy, ControlValueAccessor {
    public form: FormGroup
    private subscriptions = new Subscription();
    public isOn$: Observable<boolean>
    @Input() value: boolean | undefined;
    @Input() disabled: boolean | undefined;
    @Input() onText: string='ON'
    @Input() offText: string='OFF'
    @Output() change = new EventEmitter<{ checked: boolean }>()

    constructor(fb: FormBuilder,) {
        this.form = fb.group({value: undefined})
        this.isOn$ = (this.form.get('value') as any)?.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                const value = this.form.get('value')?.value;
                return value == true;
            })
        )
        this.subscriptions.add(
            (this.form.get('value') as any)?.valueChanges.pipe(
                filter(() => this.form.enabled)
            )
                .subscribe((value: any) => {
                    this.change.emit({checked: value == true})
                })
        )
    }

    ngOnInit() {
        if (this.value != null) {
            const currentValue = this.form.get('value')?.value;
            if (this.value != currentValue) {
                this.form.get('value')?.setValue(this.value, {emitEvent: false});
            }
        } else {
            this.form.get('value')?.reset(undefined, {emitEvent: false});
        }
    }

    ngOnChanges(changes: SimpleChanges) {

        if (changes.disabled != null) {
            if (this.disabled == true) {
                this.form.get('value')?.disable()
            } else {
                this.form.get('value')?.enable();
            }
        }
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const values$ = this.form.valueChanges.pipe(
            startWith(undefined),
            map(() => {
                const values = this.form.value;
                if (values != null) {
                    return values.value;
                } else {
                    return undefined;
                }
            })
        )
        this.subscriptions.add(
            values$.subscribe(onChange)
        );

    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable();
        } else {
            this.form.enable();
        }
    }

    writeValue(value: SensorEventStatement) {
        if (isNotNullOrUndefined(value)) {
            setTimeout(() => {
                this.form.get('value')?.setValue(value)
            })
        } else if (value) {
            this.form.reset()
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        // if (!isNotNullOrUndefined(this.form.get('autoComplete')?.validator)) {
        //     this.form.get('autoComplete')?.setValidators(control.validator)
        //     this.form.get('autoComplete')?.updateValueAndValidity()
        // }
        if (this.form.valid) {
            return null
        } else {
            return this.form.errors!;
        }
    }

    addControlErrors(allErrors: any, controlName: string) {
        const errors = {...allErrors};
        const controlErrors = this.form.controls[controlName].errors;
        if (controlErrors) {
            errors[controlName] = controlErrors;
        }
        return errors;
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    activeDisactive() {
        if (this.form.enabled) {
            const currentValue = this.form.get('value')?.value;
            this.form.get('value')?.setValue(!currentValue);
        }
    }
}
